import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';
import type { VariationImageResponse } from '../types/variationImage.ts';

export async function getVariationImages(
  variationRequestId: string
): Promise<VariationImageResponse[]> {
  const response = await authenticatedApi.get<VariationImageResponse[]>(
    `/api/mobile/v1/variations/${variationRequestId}/images`
  );
  return response.data;
}
